/**
 * Logger interface for structured logging
 */
export interface Logger {
  // eslint-disable-next-line no-unused-vars
  info(message: string, meta?: Record<string, unknown>): void;
  // eslint-disable-next-line no-unused-vars
  error(message: string, error?: Error, meta?: Record<string, unknown>): void;
  // eslint-disable-next-line no-unused-vars
  debug(message: string, meta?: Record<string, unknown>): void;
  // eslint-disable-next-line no-unused-vars
  warn(message: string, meta?: Record<string, unknown>): void;
}

/**
 * Default console logger implementation
 */
export class ConsoleLogger implements Logger {
  info(message: string, meta?: Record<string, unknown>): void {
    console.log(`[INFO] ${message}`, meta ? JSON.stringify(meta) : '');
  }

  error(message: string, error?: Error, meta?: Record<string, unknown>): void {
    console.error(`[ERROR] ${message}`, error?.message || '', meta ? JSON.stringify(meta) : '');
  }

  debug(message: string, meta?: Record<string, unknown>): void {
    console.debug(`[DEBUG] ${message}`, meta ? JSON.stringify(meta) : '');
  }

  warn(message: string, meta?: Record<string, unknown>): void {
    console.warn(`[WARN] ${message}`, meta ? JSON.stringify(meta) : '');
  }
}

/**
 * No-op logger for production or testing
 */
export class NoOpLogger implements Logger {
  info(): void {
    // No operation
  }

  error(): void {
    // No operation
  }

  debug(): void {
    // No operation
  }

  warn(): void {
    // No operation
  }
}